<template>
  <div class="send-msg-box">
    <div class="icon-box">
      <van-icon name="info" color="#1890ff" size="70" />
    </div>
    <div class="info-box">
      <div class="info-line">
        <span class="label">{{ $t('options.请使用') }}</span>
        <span class="value">{{ form.phone }}</span>
      </div>
      <div class="info-line">
        <span class="label">{{ $t('options.编辑短信') }}</span>
        <span class="value">{{ `HBSJ${code}` }}</span>
        <van-tag class="copy-btn" type="primary" @click="handleCopy(`HBSJ${code}`)">
          {{ $t('options.复制') }}
        </van-tag>
      </div>
      <div class="info-line">
        <span class="label">{{ $t('options.发送到') }}</span>
        <span class="value">10692999335170</span>
        <van-tag class="copy-btn" type="primary" @click="handleCopy('10692999335170')">{{$t('options.复制')}}</van-tag>
      </div>
    </div>
    <div style="margin: 16px;">
      <van-button
        block
        type="primary"
        size="large"
        @click="handleSendMsg"
        :loading="btnLoading"
      >
        {{ sendStatus === 0 ? $t('options.已发送短信') : $t('options.验证中') }}
        {{ currentSecond ? `(${currentSecond}${$t('options.秒')})` : '' }}
      </van-button>
    </div>
    <div class="flex-box" @click="handleOpenMsg">
      {{$t('options.点击一键发送')}}
    </div>
  </div>
</template>

<script>
  import { copyText, judgeDeviceType } from '@/utils/util';
  import { isPhoneSendMsg } from '@/api/user';

  export default {
    props: {
      form: {
        type: Object,
        default: () => ({
          phone: '',
          new_phone: '',
        }),
      },
      code: {
        type: [String, Number],
        default: '',
      }
    },
    data() {
      return {
        timer: null,
        msgTimer: null,
        currentSecond: 0,
        btnLoading: false,
        // 0：代表还未点击下一步，1：代表已经点击下一步'
        // 点击之后去轮询接口，查看是否发送成功
        sendStatus: 0
      };
    },
    created () {
      // this.currentSecond = 30;
      // this.setTimer();
    },
    methods: {
      handleCopy (text) {
        copyText(text).then(() => {
          this.$toast(this.$t('options.复制成功'));
        });
      },
      handleOpenMsg () {
        this.$dialog.confirm({
          title: this.$t('options.提示'),
          message: `${this.$t('options.请确认当前手机号码为')} “${this.form.phone}” !`
        }).then(() => {
          const isIos = judgeDeviceType().isIOS;
          const a = document.createElement('a');
          // const msg = encodeURIComponent(`${this.$t('options.换绑手机')}${this.form.new_phone}`);
          const msg = `HBSJ${this.code}`;
          if (isIos) {
            a.href = `sms:10692999335170&body=${msg}`;
          } else {
            a.href = `sms:10692999335170?body=${msg}`;
          }
          a.click();
        });
      },
      setTimer () {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
        this.timer = setInterval(() => {
          if (this.currentSecond > 0) {
            this.currentSecond -= 1;
          } else {
            this.currentSecond = 0;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      },
      // 轮询短信状态
      msgStatusTimer () {
        if (this.msgTimer) {
          clearInterval(this.msgTimer);
          this.msgTimer = null;
        }
        this.msgTimer = setInterval(() => {
          if (this.currentSecond > 0) {
            this.validateMsg();
          } else {
            clearInterval(this.msgTimer);
            this.msgTimer = null;
          }
        }, 5000);
      },
      // 验证
      validateMsg () {
        isPhoneSendMsg({ old_phone: this.form.phone, content: `HBSJ${this.code}`, code: this.code }, false).then(res => {
          if (res.code === 0) {
            this.sendStatus === 0;
            this.currentSecond = 0;
            clearInterval(this.timer);
            this.timer = null;
            clearInterval(this.msgTimer);
            this.msgTimer = null;
            this.$emit('sendMsg');
          } else {
            if (this.currentSecond <= 0) {
              this.sendStatus = 0;
            }
          }
        });
      },
      handleSendMsg () {
        if (this.timer || this.currentSecond > 0) {
          return;
        }
        if (this.sendStatus === 0) {
          this.sendStatus = 1;
          this.currentSecond = 30;
          this.setTimer();
          this.msgStatusTimer();
          this.validateMsg();
        }
      }
    }
  };
</script>

<style lang="less" scoped>
.send-msg-box {
  width: 100%;
  margin-top: 10px;
  .icon-box {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
  }
  .info-box {
    display: flex;
    flex-direction: column;
    padding-left: 60px;
    .info-line {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      .label {
        font-size: 14px;
        color: #333;
        margin-right: 10px;
      }
      .value {
        font-size: 14px;
        color: #E64C5C;
      }
      .copy-btn {
        margin-left: 4px;
      }
    }
  }
  .flex-box {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1890ff;
    font-size: 12px;
    text-decoration: underline;
  }
  .back-top {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #1890ff;
  }
}
</style>